import { SVGProps, Ref, forwardRef } from 'react';

export const BottleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m13 13.333-.006.832-.01.258c-.033.571-.129.93-.403 1.186-.314.293-.771.367-1.548.385l-.89.006H5.857l-.89-.006c-.712-.017-1.156-.08-1.467-.315l-.081-.07c-.314-.292-.393-.72-.413-1.444L3 13.333v-1.3h10z"
            fill="currentColor"
        />
        <path
            d="M11.691 5.367c.205.723.509 1.433 1.105 2.824.1.236.15.354.177.478l.002.004c.025.123.025.25.025.498v1.463H3V9.17c0-.187 0-.304.01-.403l.015-.095.002-.004q.01-.046.024-.094l.036-.102.117-.282.001-.003c.532-1.241.832-1.94 1.036-2.59l.068-.23z"
            fill="currentColor"
        />
        <path
            d="M11.7 1.4h-.655l.117.878c.094.7.167 1.239.237 1.689H4.601c.032-.206.065-.43.1-.68l.137-1.009.117-.878H4.3V0h7.4z"
            fill="currentColor"
        />
    </svg>
));
BottleFilledSize16Glyph.displayName = 'BottleFilledSize16Glyph';
